<template>
  <div class="container-fluid">
    <div data-widget-group="group1">
      <ol class="breadcrumb">
        <li>
          <router-link to="/admin">Dashboard</router-link>
        </li>
        <li class="active">
          Report Product Coupons Details
        </li>
      </ol>

      <!-- Filters Row -->
      <div class="row">
        <div class="col-md-3">
          <div id="search-box">
            <div class="form-group">
              <label for="searchbox">Search</label>
              <input
                type="text"
                class="search-query form-control"
                placeholder="Search Part Number"
                v-model="searchText"
              />
            </div>
          </div>
        </div>      
        <div class="col-md-3">
          <div class="form-group">
            <label for="from">From Month</label>
            <datepicker
              :minimumView="'month'"
              :maximumView="'year'"
              :initialView="'year'"
              :bootstrapStyling="true"
              @selected="fromDateSelect"
            ></datepicker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="To">To Month</label>
            <datepicker
              :minimumView="'month'"
              :value="newLastMonthDate"
              :maximumView="'year'"
              :initialView="'year'"
              :bootstrapStyling="true"
              @selected="toDateSelect"
            ></datepicker>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="PartnerType">Partner Type</label>
            <v-select
              v-model="PartnerTypeSelected"
              :options="PartnerOptions"
              :reduce="partnerDetails => partnerDetails.code"
              label="name"
            />
          </div>
        </div>
      </div>

      <!-- Buttons Row -->
      <div class="row">
        <div class="col-md-2 col-md-offset-7">
          <div class="form-group">
            <button
              type="button"
              @click="getAllCoupons(1)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Filter
            </button>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <button
              type="button"
              @click="exportReport(0)"
              class="btn btn-raised btn-primary submitbtn"
            >
              Export To CSV
            </button>
          </div>
        </div>
      </div>

      <!-- Status Buttons -->
      <div class="row">
        <div class="col-md-12">
          <button
            type="button"
            @click="filterTotalCoupon"
            class="btn btn-default"
            :class="{'active': FilterSetOnClick == ''}"
          >
            Total Coupons <span class="badge">{{ TotalCoupon }}</span>
          </button>
          <button
            type="button"
            @click="filterAvaialable"
            class="btn btn-default"
            :class="{'active': FilterSetOnClick == 'Available'}"
          >
            Marry Coupons <span class="badge">{{ AvailableCoupon }}</span>
          </button>
          <button
            type="button"
            @click="filterNewGenerated"
            class="btn btn-default"
            :class="{'active': FilterSetOnClick == 'NewGenerate'}"
          >
            New Generated Coupons <span class="badge">{{ GeneratedCoupon }}</span>
          </button>
        </div>
      </div>

      <!-- Table -->
      <div class="row">
        <div class="col-md-12">
          <div class="panel panel-default visibility" id="panel-inline">
            <div class="panel-heading"></div>
            <div class="panel-body no-padding visibility">
              <table class="table table-striped table-bordered" cellspacing="0" width="100%">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Coupon ID</th>
                    <th>Serial Number</th>
                    <th>Product Name</th>
                    <th>Points</th>
                    <th>Reborer Status</th>
                    <th>Mechanic Status</th>
                    <th>Grinder Status</th>
                    <th>Grinder Reborer Status</th>
                    <th>Retailer Status</th>
                    <th>Updation Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in coupon_data" :key="item.id" class="gradeC">
                    <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                    <td>{{ item.coupon }}</td>
                    <td>{{ item.serial_number }}</td>
                    <td>{{ item.ProductName }}</td>
                    <td>{{ item.points }}</td>
                    <td>{{ item.ReborerStatus }}</td>
                    <td>{{ item.MechanicStatus }}</td>
                    <td>{{ item.GrinderStatus }}</td>
                    <td>{{ item.GrinderReborerStatus }}</td>
                    <td>{{ item.RetailerStatus }}</td>
                    <td>{{ item.modified_date ? item.modified_date : item.created_date | dateFormatReadable }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div class="panel-footer">
              <paginate
                :page-count="TotalPage"
                :click-handler="getAllCoupons"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
              ></paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate';
import commonServices from '../../services/common-services';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'couponMaster',
  components: { Paginate, Datepicker, vSelect },
  data() {
    return {
      coupon_data: [],
      searchText: '',
      pageSize: 10,
      TotalPage: 1,
      currentPage: 1,
      AvailableCoupon: 0,
      GeneratedCoupon: 0,
      TotalCoupon: 0,
      FilterSetOnClick: '',
      newLastMonthDate: '',
      PartnerOptions: [
        { code: 'Retailer', name: 'Retailer' },
        { code: 'Reborer', name: 'Reborer' },
        { code: 'Grinder', name: 'Grinder' },
        { code: 'ReborerPlusGrinder', name: 'Reborer Plus Grinder' },
        { code: 'Mechanics', name: 'Mechanics' },
      ],
      PartnerTypeSelected: ''
    };
  },
  methods: {
    // Filter Buttons
    filterTotalCoupon() { this.FilterSetOnClick = ''; this.getAllCoupons(1); },
    filterNewGenerated() { this.FilterSetOnClick = 'NewGenerate'; this.getAllCoupons(1); },
    filterAvaialable() { this.FilterSetOnClick = 'Available'; this.getAllCoupons(1); },

    fromDateSelect(date) { this.fromMonthYear = date; },
    toDateSelect(date) {
      this.newLastMonthDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      this.toMonthYear = this.newLastMonthDate;
    },

    getRequestParams(searchText, page, pageSize) {
      const params = {};
      if (this.FilterSetOnClick) params['FilterSetOnClick'] = this.FilterSetOnClick;
      if (this.PartnerTypeSelected) params['PartnerTypeSelected'] = this.PartnerTypeSelected;
      if (this.fromMonthYear) params['fromMonthYear'] = this.fromMonthYear;
      if (this.toMonthYear) params['toMonthYear'] = this.toMonthYear;
      if (searchText) params['searchText'] = searchText;
      if (page) params['page'] = page; // 1-based
      if (pageSize) params['size'] = pageSize;
      return params;
    },

    exportReport() {
      const loader = this.$loading.show();
      const params = this.getRequestParams(this.searchText, 0, this.pageSize);
      commonServices.get('kspgAPI/Coupon/productListReportExport', params)
        .then((response) => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', 'Product_Report.csv');
          document.body.appendChild(fileLink);
          fileLink.click();
          loader.hide();
        });
    },

    getAllCoupons(pageNum) {
      const loader = this.$loading.show();
      const params = this.getRequestParams(this.searchText, pageNum, this.pageSize);
      commonServices.get('kspgAPI/Coupon/productListReport', params)
        .then((response) => {
          const { coupon_data, TotalPage, currentPage, AvailableCoupon, GeneratedCoupon, TotalCoupon } = response.data;
          this.coupon_data = coupon_data;
          this.TotalPage = TotalPage;
          this.currentPage = parseInt(currentPage);
          this.AvailableCoupon = AvailableCoupon;
          this.GeneratedCoupon = GeneratedCoupon;
          this.TotalCoupon = TotalCoupon;
          loader.hide();
        })
        .catch(() => loader.hide());
    },
  },
  mounted() {
    this.getAllCoupons(1);
  },
  filters: {
    dateFormatReadable(input_date) {
      return input_date ? moment(String(input_date)).format('DD-MM-YYYY') : input_date;
    },
  },
};
</script>

<style scoped>
.visibility { visibility: visible !important; }
.left-align { text-align: left !important; }
</style>
